import {
  concessionServiceBaseUrl,
  enrollmentServiceBaseUrl,
} from "services/http";

export const consessionServiceEndpoints = {
  treeView: `${concessionServiceBaseUrl}/category/tree`,
  category: `${concessionServiceBaseUrl}/category`,
  subCategory: `${concessionServiceBaseUrl}/subCategory`,
  subSubCategory: `${concessionServiceBaseUrl}/subSubCategory`,
  masterFilter: `${concessionServiceBaseUrl}/category/tree/search`,
  concessionSlab: `${concessionServiceBaseUrl}/concession-slab`,
  getConcessionSlabBySubCategory: `${concessionServiceBaseUrl}/concession-slab/subCategory`,
  getConcessionSlabBySubSubCategory: `${concessionServiceBaseUrl}/concession-slab/subSubCategory`,
  allConsessionslabs: `${concessionServiceBaseUrl}/concession-slab/all`,
  exportConsessionSlab: `${concessionServiceBaseUrl}/concession-slab/exportToCsv`,
  getAllConcessionUploadDetails: `${concessionServiceBaseUrl}/getAllConcessionUploadDetails`,
  getMasterMapping: `${concessionServiceBaseUrl}/category/getCategoryMasterConfig`,
  getHouseBankList: `${concessionServiceBaseUrl}/getAllHouseBank`,
  bankAccount: `${concessionServiceBaseUrl}/bankAccount`,
  sapPeriodStatus: {
    getAllPeriodStatus: `${concessionServiceBaseUrl}/sapPeriodStatus/getAllPeriodStatus`,
  },
  sapProfitCostCentreMapping: {
    getAll: `${concessionServiceBaseUrl}/getAllProfitCostCenter`,
    createProfitCostCenter: `${concessionServiceBaseUrl}/createProfitCostCenter`,
    updateProfitCostCenter: `${concessionServiceBaseUrl}/updateProfitCostCenter`,
    deleteProfitCostCenter: `${concessionServiceBaseUrl}/deleteProfitCostCenter`,
    getAllProfitCenter: `${concessionServiceBaseUrl}/profitCenter/getAllProfitCenter`,
    searchProfitCostCenter: `${concessionServiceBaseUrl}/searchProfitCostCenter`,
  },
  findSlabByParams: `${concessionServiceBaseUrl}/concession-slab/findSlabByParams`,
  //migrated
  otherChargesConcession: {
    getAllOtherCharegesById: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/applicationId`,
    create: `${concessionServiceBaseUrl}/applicationOtherChargesDetails`,
    updateStatus: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/status`,
  },
  updateStudentChargeSummary: `${concessionServiceBaseUrl}/studentApplicationCharges/updateSummaryKey`,
  updateStudentQuotationStatus: `${concessionServiceBaseUrl}/studentApplicationCharges/applicationQuotation/changeStatus`,
  applicationQuotationDetails: `${concessionServiceBaseUrl}/studentApplicationCharges/applicationQuotationDetails`,
  getApplicationNetPayable: `${concessionServiceBaseUrl}/studentApplicationCharges/getApplicationNetpayable`,
  studentChargesConcessionDetailsConcession: {
    getByApplicationId: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/applicationId`,
    post: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/save`,
  },
  savedBreakup: `${concessionServiceBaseUrl}/studentChargesFeeBreakup/applicationQuotationDetails`,
  concessionConfigConc: {
    getAll: `${concessionServiceBaseUrl}/customConcessionConfig/getAllActiveConfig`,
    getFilteredConfig: `${concessionServiceBaseUrl}/customConcessionConfig/getFilteredConfig`
  },
  categoryCode: `${concessionServiceBaseUrl}/categoryCode`,
  loanScheme: `${concessionServiceBaseUrl}/loanSchemeMaster`,
  concessionFiles: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDocument`,
  uploadOtherCharges: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/uploadDocument`,
  otherChargesDocument: {
    upload: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/uploadDocument`,
    get: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/getDocumentbyOtherChargeId`,
    verifyDocument: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/updateDocumentStatus`,
    deleteFile: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/deleteDocument`,
  },

  studentDetailsConc: {
    countByChargeStatus: `${concessionServiceBaseUrl}/studentApplicationCharges/getCountByChargeStatus`,
  },
  approvalConcession: {
    getAllApprovalRequests: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/search/approvalRequests`,
  },
  lumpSumConcession: {
    getAll: `${concessionServiceBaseUrl}/lumpSumConcession/getAllActiveLumpSumConcession`,
    create: `${concessionServiceBaseUrl}/lumpSumConcession/createLumpSumConcession`,
    delete: `${concessionServiceBaseUrl}/lumpSumConcession/deleteLumpSumConcession`,
    update: `${concessionServiceBaseUrl}/lumpSumConcession/updateLumpSumConcession`,
    getByCareerId: `${concessionServiceBaseUrl}/lumpSumConcession/getLumpSumConcessionByCareer`,
  },
  configExAakashian: {
    getById: `${concessionServiceBaseUrl}/config/exAakashian`,
    getAll: `${concessionServiceBaseUrl}/config/exAakashian/all`,
    delete: `${concessionServiceBaseUrl}/config/exAakashian`,
    update: `${concessionServiceBaseUrl}/config/exAakashian`,
    create: `${concessionServiceBaseUrl}/config/exAakashian`,
    validate: `${concessionServiceBaseUrl}/config/exAakashian/validate`,
  },
  concessionConfig: {
    create: `${concessionServiceBaseUrl}/customConcessionConfig/createConfig`,
    update: `${concessionServiceBaseUrl}/customConcessionConfig/updateConfig`,
    delete: `${concessionServiceBaseUrl}/customConcessionConfig/deleteConfig`,
    search: `${concessionServiceBaseUrl}/customConcessionConfig/searchConfig`,
  },
  leftOutAdmissionConfig: {
    getById: `${concessionServiceBaseUrl}/leftOutAdmissionConfig/getLeftOutAdmissionConfigById`,
    getAll: `${concessionServiceBaseUrl}/leftOutAdmissionConfig/getAllLeftOutAdmissionConfig`,
    create: `${concessionServiceBaseUrl}/leftOutAdmissionConfig/create`,
    update: `${concessionServiceBaseUrl}/leftOutAdmissionConfig/update`,
    delete: `${concessionServiceBaseUrl}/leftOutAdmissionConfig/delete`,
    search: `${concessionServiceBaseUrl}/leftOutAdmissionConfig/searchLeftOutAdmissionConfigs`,
  },
  scholarshipConfig: {
    getById: `${concessionServiceBaseUrl}/scholarshipConfig/getScholarshipConfigById`,
    getAll: `${concessionServiceBaseUrl}/scholarshipConfig/getAllScholarshipConfig`,
    create: `${concessionServiceBaseUrl}/scholarshipConfig/create`,
    update: `${concessionServiceBaseUrl}/scholarshipConfig/update`,
    delete: `${concessionServiceBaseUrl}/scholarshipConfig/delete`,
    search: `${concessionServiceBaseUrl}/scholarshipConfig/searchScholarshipConfigs`,
  },
  //
  studentChargesConcessionDetails: {
    sendForApproval: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/saveAndSendForApproval`,
    post: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/save`,
    send: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/send`,
    revoke: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/revoke`,
  },
  getConssessionDetails: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/applicationQuotationDetailsId`,
  getConssessionDetailsByApplicationId: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/applicationId`,
  finalizeCharges: `${concessionServiceBaseUrl}/studentChargesFeeBreakup`,

  approval: {
    status: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/updateApprovalStatus`,
    export: `${concessionServiceBaseUrl}/applicationApprovalRequests/export`,
    getAverageArpuData: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/getAverageArpuData`,
  },
  otherCharges: {
    getOtherCharges: `${concessionServiceBaseUrl}/studentCharges/otherCharges/applicationId`,
    getAll: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/applicationId`,
    otherChargesForApproval: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/search/approvalRequests`,
    modificationCount: `${concessionServiceBaseUrl}/studentCharges/getModificationCount`,
  },
  getDocumentsByapplicationConcessionId: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDocument/concession`,
  verifyDocuments: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDocument/verify`,
  loanCareerValidation: {
    create: `${concessionServiceBaseUrl}/loan-career-validation/createLoanCareerValidation`,
    update: `${concessionServiceBaseUrl}/loan-career-validation/updateLoanCareerValidation`,
    getAll: `${concessionServiceBaseUrl}/loan-career-validation/getAllLoanCareerValidation`,
    delete: `${concessionServiceBaseUrl}/loan-career-validation/deleteLoanCareerValidation`,
    search: `${concessionServiceBaseUrl}/loan-career-validation/searchLoanCareerSetup`,
    getActiveLoanSetupByBUAndAcadCareer: `${concessionServiceBaseUrl}/loan-career-validation/getActiveLoanSetupByBUAndAcadCareer`,
  },
  getStudentChargesAuditByQuotation: `${concessionServiceBaseUrl}/studentCharges/getStudentChargesAuditByApplication`,
  deliveryOrder: {
    deliveryOrderDetails: `${concessionServiceBaseUrl}/deliveryOrderDetails`, // same endpoint for create and edit as well
    doIdAndVendorDetail: `${concessionServiceBaseUrl}/deliveryOrderDetails/doIdAndVendorDetail`,
  },
  eligibleDepositSlips: `${concessionServiceBaseUrl}/studentChargesFeeBreakup/getEligibleDepositSlipByQuotationId`,
  allDepositeSlip: `${concessionServiceBaseUrl}/studentChargesFeeBreakup/getDepositSlipsByQuotation`,
  depositSlipReferenceNosByApplication: `${concessionServiceBaseUrl}/studentChargesFeeBreakup/depositSlipReferenceNosByApplication`,
  qrCode: {
    searchQr: `${concessionServiceBaseUrl}/qrCode/searchQR`,
    saveQr: `${concessionServiceBaseUrl}/qrCode/saveQR`,
    updateQr: `${concessionServiceBaseUrl}/qrCode/updateQR`,
    deleteQr: `${concessionServiceBaseUrl}/qrCode/deleteQR`,
  },
  saveDepositSlip: `${concessionServiceBaseUrl}/studentChargesFeeBreakup/saveDepositSlip`,
  getDepositSlipInfoByApplication: `${concessionServiceBaseUrl}/studentChargesFeeBreakup/getDepositSlipInfoByApplication`,
  allQuotations: `${concessionServiceBaseUrl}/studentApplicationCharges/getAllQuotationByApplication`,
  notifyDepositSlip: `${concessionServiceBaseUrl}/notifyDepositSlip`,
  feeBreakfromPricingByApplicationId: `${concessionServiceBaseUrl}/studentApplicationCharges/getFeeBreakupWithTaxByApplicationIdAndQuotationId`,
  getChargesWithFeeBreakupAndGstDetails: `${concessionServiceBaseUrl}/studentApplicationCharges/getChargesWithFeeBreakupAndGstDetails`,
  checkModifyAllowed: `${concessionServiceBaseUrl}/studentCharges/chargeModificationEligibility`,
  paidItemTypeList: `${concessionServiceBaseUrl}/studentCharges/getApplicationItemTypePaymentDetail`,

  getAutoConcessions: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/getAllAutoConcession`,
  getScoreByPsidExam: `${concessionServiceBaseUrl}/testPlayer/getScoreByPsidExam`,

  downloadApprovalRequests: {
    downloadChargesRequests: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/downloadApplicationApprovalRequests`,
    downloadOtherChargesRequests: `${concessionServiceBaseUrl}/studentApplicationCharges/concessionDetails/downloadApplicationOtherChargesApprovalRequests`,
  },

  paymentGatewayConfig: {
    search: `${concessionServiceBaseUrl}/paymentGatewayConfig/searchPaymentGatewayConfig`,
    create: `${concessionServiceBaseUrl}/paymentGatewayConfig/create`,
    update: `${concessionServiceBaseUrl}/paymentGatewayConfig/update`,
  },
  sdChargePayment: {
    search: `${concessionServiceBaseUrl}/payment/sdCharge/searchSecurityDepositConfiguration`,
    create: `${concessionServiceBaseUrl}/payment/sdCharge/createSecurityDepositConfiguration`,
    update: `${concessionServiceBaseUrl}/payment/sdCharge/updateSecurityDepositConfiguration`,
    delete: `${concessionServiceBaseUrl}/payment/sdCharge/deleteSecurityDepositConfiguration`,
  },
  getFeeBreakupWithPaymentDetails: `${concessionServiceBaseUrl}/studentApplicationCharges/getFeeBreakupWithPaymentDetails`,

  bankMaster: {
    search: `${concessionServiceBaseUrl}/payment/bankMaster/searchBank`,
    create: `${concessionServiceBaseUrl}/payment/bankMaster/createBank`,
    update: `${concessionServiceBaseUrl}/payment/bankMaster/updateBank`,
  },

  posMapping: {
    search: `${concessionServiceBaseUrl}/payment/posMapping/searchPosMapping`,
    create: `${concessionServiceBaseUrl}/payment/posMapping/create`,
    update: `${concessionServiceBaseUrl}/payment/posMapping/update`,
  },

  onlineSaleMaster: {
    getAllOnlineVendor: `${concessionServiceBaseUrl}/payment/onlineSaleMaster/getAllOnlineVendor`,
  },
  cardTypeMaster: {
    getAllCardType: `${concessionServiceBaseUrl}/payment/cardTypeMaster/getAllCardType`,
  },

  paymentCollection: {
    getApplicationCharges: `${concessionServiceBaseUrl}/payment/collection/getChargesBySequencing`,
    validatePaymentMode: `${concessionServiceBaseUrl}/payment/collection/validatePaymentMode`,
    collectPayment: `${concessionServiceBaseUrl}/payment/collection/collectPayment`,
    getFailedCheckDetails: `${concessionServiceBaseUrl}/payment/collection/failedChequeDetails`,
    getVouchersAndPaymentMode: `${concessionServiceBaseUrl}/payment/collection/getVouchersAndPaymentMode`,
    getJodoHistory: `${concessionServiceBaseUrl}/payment/collection/getJodoHistory`,
    createReceipt: `${concessionServiceBaseUrl}/payment/collection/createReceipt`,
    getOutstandingAmountByApplicationIdAndPsid: `${concessionServiceBaseUrl}/payment/collection/getOutstandingAmountByApplicationIdAndPsid`,
    validateSequencing: `${concessionServiceBaseUrl}/payment/collection/validateSequencing`,
    getAudit: `${concessionServiceBaseUrl}/collection/audit`,
    initiatePayment: `${concessionServiceBaseUrl}/paymentIntegration/initiatePaymentSession`,
    getPaymentStatus: `${concessionServiceBaseUrl}/paymentIntegration/getTransactionStatus`,
    cancelTransaction: `${concessionServiceBaseUrl}/paymentIntegration/cancelTransaction`,
    getJodoPaymentCollectionDetails: `${concessionServiceBaseUrl}/paymentIntegration/getJodoPaymentCollectionDetails`,
    review: `${concessionServiceBaseUrl}/payment/collection/review`,
    chargeDetail: `${concessionServiceBaseUrl}/payment/collection/chargeDetail`,
    getStudentCourseWiseInformation: `${concessionServiceBaseUrl}/payment/collection/getStudentCourseWiseInformation`,
  },
  paymentMode: {
    search: `${concessionServiceBaseUrl}/paymentMode/searchPaymentMode`,
    getAll: `${concessionServiceBaseUrl}/paymentMode/getAllPaymentMode`,
    create: `${concessionServiceBaseUrl}/paymentMode/createPaymentMode`,
    update: `${concessionServiceBaseUrl}/paymentMode/updatePaymentMode`,
    delete: `${concessionServiceBaseUrl}/paymentMode/deletePaymentMode`,
    getActive: `${concessionServiceBaseUrl}/paymentMode/getActivePaymentMode`,
    getAllActivePaymentCategory: `${concessionServiceBaseUrl}/paymentMode/getAllActivePaymentCategory`,
    processAndRoleMapping: {
      create: `${concessionServiceBaseUrl}/paymentMode/createProcessAndRoleMapping`,
      update: `${concessionServiceBaseUrl}/paymentMode/updateProcessAndRoleMapping`,
      getAuditByPaymentModeIdAndProcessId: `${concessionServiceBaseUrl}/paymentMode/getAuditByPaymentModeIdAndProcessId`,
    },

    receiptAccountEntrySetup: {
      accountEntries: `${concessionServiceBaseUrl}/paymentMode/receiptAccountEntry`,
    },
  },

  paymentDetails: `${concessionServiceBaseUrl}/paymentDetails`,
  getAllPaymentItems: `${concessionServiceBaseUrl}/applicationOtherChargesDetails/getAllPaymentDetails`,
  getVanDetailsApplicationIdAndPsid: `${concessionServiceBaseUrl}/studentApplicationCharges/getVanDetailsApplicationIdAndPsid`,

  invoice: {
    getInvoiceDetailsByItemTypeNo: `${concessionServiceBaseUrl}/invoiceGenerator/getInvoiceDetailsByItemTypeNo`,
    generateInvoicePdf: `${concessionServiceBaseUrl}/pdf/generateInvoicePdf`,
  },


  manageReceipts: {
    search: `${concessionServiceBaseUrl}/payment/receipt/searchReceipts`,
    getDetails: `${concessionServiceBaseUrl}/payment/receipt/details`,
    view: `${concessionServiceBaseUrl}/payment/receipt/viewReceipt`,
    amount: `${concessionServiceBaseUrl}/payment/receipt/amount`,
    receiptDetails: `${concessionServiceBaseUrl}/payment/receipt/receiptDetails`,
    sendNotif: `${concessionServiceBaseUrl}/payment/receipt/sendNotification`,
    paymentInfo: `${concessionServiceBaseUrl}/payment/receipt/paymentInfo`,
    downloadAttachment: `${concessionServiceBaseUrl}/payment/receipt/downloadAttachment`,
    paymentMode: `${concessionServiceBaseUrl}/payment/receipt/paymentMode`,
    audit: `${concessionServiceBaseUrl}/payment/receipt/receiptDetailsAuditByBusinessAreaId`,
    viewReceiptsInstallmentWise: `${concessionServiceBaseUrl}/payment/receipt/viewReceiptsInstallmentWise`,
  },

  getAllActiveReceiptType: `${concessionServiceBaseUrl}/payment/receiptType/getAllActiveReceiptType`,
  downloadReports: `${concessionServiceBaseUrl}/payment/collection/downloadReport`,

  paymodeApproval: {
    search: `${concessionServiceBaseUrl}/approval/searchPaymodeUpdateApproval`,
    updateStatus: `${concessionServiceBaseUrl}/approval/updateStatusForPaymodeChange`,
    submitPaymodeUpdateRequest: `${concessionServiceBaseUrl}/approval/submitPaymodeUpdateRequest`,
    checkPaymentModeApprovalStatus: `${concessionServiceBaseUrl}/approval/checkPaymentModeApprovalStatus`,
  },
  epmrReceipt: {
    search: `${concessionServiceBaseUrl}/epmrReceipt/searchEpmrReceipts`,
    updateStatus: `${concessionServiceBaseUrl}/epmrReceipt/updateStatusForEpmr`,
    audit: `${concessionServiceBaseUrl}/epmrReceipt/audit`,
  },

  studentResult: {
    getStudentResultByRollNumber: `${concessionServiceBaseUrl}/testPlayer/getStudentResultByRollNumber`,
    updatePsidByRollNumberV1: `${concessionServiceBaseUrl}/testPlayer/updatePsidByRollNumberV1`,
    updateAdjustmentFlag: `${concessionServiceBaseUrl}/testPlayer/updateAdjustmentFlag`,
    viewEditResultLogs: `${concessionServiceBaseUrl}/testPlayer/getResultAuditLogs`,
  },

  epmrConfig: {
    create: `${concessionServiceBaseUrl}/epmrConfig/create`,
    update: `${concessionServiceBaseUrl}/epmrConfig/update`,
    delete: `${concessionServiceBaseUrl}/epmrConfig/delete`,
    get: `${concessionServiceBaseUrl}/epmrConfig/getAllEmprConfig`,
  },

  chargeModification: {
    search: `${concessionServiceBaseUrl}/charges/config/search?type=chargeModify`,
    create: `${concessionServiceBaseUrl}/charges/config?type=chargeModify`,
    update: `${concessionServiceBaseUrl}/charges/config?type=chargeModify`,
  },

  TransferValidationConfig: {
    search: `${concessionServiceBaseUrl}/charges/config/search?type=transferValidations`,
    create: `${concessionServiceBaseUrl}/charges/config?type=transferValidations`,
    update: `${concessionServiceBaseUrl}/charges/config?type=transferValidations`,
  },
  concessionConfigArpu: {
    search: `${concessionServiceBaseUrl}/charges/config/search`,
    crud: `${concessionServiceBaseUrl}/charges/config`,
    getAuditLogs: `${concessionServiceBaseUrl}/charges/config/getAuditLogs`,
  },
  bulkUpload: {
    arpu: `${concessionServiceBaseUrl}/bulkUpload/getAuditDetails`,
  },

  receiptIndex: {
    getReceiptIndices: `${concessionServiceBaseUrl}/payment/receipt/receiptDetails`, // "manageReceipts.receiptDetails" & "receiptIndex.getReceiptIndices" have same url, but they are used at differnet places
  },

  parentConsent: {
    getConsentDetails: `${concessionServiceBaseUrl}/consent`,
    uploadConsent: `${concessionServiceBaseUrl}/consent/uploadConsent`,
    sendDigitalConsentNotification: `${concessionServiceBaseUrl}/consent/sendWebform`,
  },
  concessionReversalMaster: {
    create: `${concessionServiceBaseUrl}/charges/config?type=concessionReversal`,
    getLogs: `${concessionServiceBaseUrl}/charges/config/getAuditLogs`,
  },

  examCharges: {
    getExamDetails: `${concessionServiceBaseUrl}/examDetails/getStudentExamChargesDetails`,
    createExamReceipt: `${concessionServiceBaseUrl}/payment/collection/examReceipt`,
    search: `${concessionServiceBaseUrl}/examDetails/searchExamOtherCharges`,
    examTimeCode: `${concessionServiceBaseUrl}/examDetails/getExamTimeCodeDropdown`,
  },

  bulkCollection: {
    get: `${concessionServiceBaseUrl}/bulkCollection/getBulkCollectionFileAuditDetails`,
    getBulkUploadDetailsByPid: `${concessionServiceBaseUrl}/bulkCollection/getBulkUploadDetailsByPid`,
  },

  transferConfig: {
    basePath: `${concessionServiceBaseUrl}/charges/config?type=transferApproval`,
    search: `${concessionServiceBaseUrl}/charges/config/search?type=transferApproval`,
    delete: `${concessionServiceBaseUrl}/charges/config`,
  },

  transferRequests: {
    search: `${concessionServiceBaseUrl}/transfer/request/search`,
  },
  studentTransfer: {
    transferHistory: `${concessionServiceBaseUrl}/transfer/getTransferHistory`,
    transferValidations: `${concessionServiceBaseUrl}/transfer/transferValidations`,
    createTransferRequest: `${concessionServiceBaseUrl}/transfer/createTransferDetails`,
    updateTransferDetails: `${concessionServiceBaseUrl}/transfer/updateTransferDetails`,
    adjustment: `${concessionServiceBaseUrl}/transfer/adjustment`,
    search: `${concessionServiceBaseUrl}/transfer/search`,
    sendNotif: `${concessionServiceBaseUrl}/transfer/certificate/notification`,
    getTransferCertificateDetails: `${concessionServiceBaseUrl}/transfer/getTransferCertificateDetails`,
    getBulkTransferRequests: `${concessionServiceBaseUrl}/transfer/bulk/audit`,
    getBulkTransferSubmissionStatusDetails: `${concessionServiceBaseUrl}/transfer/bulk/submissions`,
  },

  securityTransfer: `${concessionServiceBaseUrl}/securityTransfer`,

  transferApproval: {
    search: `${concessionServiceBaseUrl}/transfer/searchApprovalRequests`,
    updateStatus: `${concessionServiceBaseUrl}/transfer/notifyAndUpdateApprovalStatus`,
  },

  refund: {
    completionRefund: {
      search: `${concessionServiceBaseUrl}/completionRefund/search`,
      update: `${concessionServiceBaseUrl}/completionRefund/update`,
      notificationConfig: `${concessionServiceBaseUrl}/completionRefund/config`,
      bulk: `${concessionServiceBaseUrl}/completionRefund/bulk`,
      isCourseInactive: `${concessionServiceBaseUrl}/completionRefund`,
    },
    approvalConfig: {
      getAll: `${concessionServiceBaseUrl}/approvalConfig`,
      search: `${concessionServiceBaseUrl}/approvalConfig/search`,
      basePath: `${concessionServiceBaseUrl}/approvalConfig`,
      logs: `${concessionServiceBaseUrl}/approvalConfig/logs`,
    },
    rectificationRefund: {
      viewReceiptsByApplicationIdAndPaymentMode: `${concessionServiceBaseUrl}/payment/receipt/viewReceiptsByApplicationIdAndPaymentMode`,
      viewSingleReceiptDetails: `${concessionServiceBaseUrl}/payment/receipt/viewSingleReceiptDetails`,
    },
    refundApproval: {
      search: `${concessionServiceBaseUrl}/refundApproval/search`,
      update: `${concessionServiceBaseUrl}/refundApproval/update`,
      exportAndSendCsvToEmail: `${concessionServiceBaseUrl}/refundApproval/exportAndSendCsvToEmail`,
      bulkUpdate: `${concessionServiceBaseUrl}/refundApproval/bulk/update`,
    },
    view: `${concessionServiceBaseUrl}/refunds/getRefundDetails`,
    refundreason: `${concessionServiceBaseUrl}/refundReason/all`,
    thirdPartyBankMaster: {
      search: `${concessionServiceBaseUrl}/loans/search`,
      create: `${concessionServiceBaseUrl}/loans`,
      update: `${concessionServiceBaseUrl}/loans`,
      delete: `${concessionServiceBaseUrl}/loans`,
    },
    audit: `${concessionServiceBaseUrl}/refund/getLogs`,
    createRefund: `${concessionServiceBaseUrl}/refunds/createRefund`,
    updateRefund: `${concessionServiceBaseUrl}/refunds/updateRefund`,
    benificiaryDetails: `${concessionServiceBaseUrl}/refunds/accountDetails`,

    multiTypeRefund: {
      payableAmount: `${concessionServiceBaseUrl}/refunds/payableAmount`,
    },

    updateRefund: `${concessionServiceBaseUrl}/refunds/updateRefund`,
    refundPoliciesSearch: `${concessionServiceBaseUrl}/refundPolicies/search`,
    refundPolicies: `${concessionServiceBaseUrl}/refundPolicies`,
    initiateCompletionRefund: `${concessionServiceBaseUrl}/refunds/initiateCompletionRefund`,
  },

  refundTracker: {
    search: `${concessionServiceBaseUrl}/refund/search`,
  },

  studentBankDetails: {
    getBankDetailsByPsid: `${concessionServiceBaseUrl}/bank/details`,
    create: `${concessionServiceBaseUrl}/bank/create`,
    update: `${concessionServiceBaseUrl}/bank/update`,
  },
  programActionUpdate: {
    getProgramActionTree: `${concessionServiceBaseUrl}/progAction`,
    updateProgramAction: `${concessionServiceBaseUrl}/progAction`,
    getProgramActionReasonMapping: `${enrollmentServiceBaseUrl}/progAction/mapping`,
    getHistory: `${enrollmentServiceBaseUrl}/progAction/history`,
    getDiscontinueFeedback: `${enrollmentServiceBaseUrl}/student-discontinue-feedback/application`,
  },
  cashManagement: {
    cashControlConfig: {
      search: `${concessionServiceBaseUrl}/cash/control/search`,
      create: `${concessionServiceBaseUrl}/cash/control`,
      update: `${concessionServiceBaseUrl}/cash/control`,
    },
    cashDashboard: {
      list: `${concessionServiceBaseUrl}/paymentManagement/cash/searchAllTotalBuDetails`,
      receiptList: `${concessionServiceBaseUrl}/paymentManagement/cash/searchAllReceipts`,
      sendForApproval: `${concessionServiceBaseUrl}/paymentManagement/cash/depositSlip/save`,
      downloadReport: `${concessionServiceBaseUrl}/paymentManagement/cash/sendPaymentReceiptsViaEmail`,
      depositedList: `${concessionServiceBaseUrl}/paymentManagement/cash/searchAllDepositSlips`,
    },
    chequeDashboard: {
      list: `${concessionServiceBaseUrl}/paymentManagement/CHKL/searchAllTotalBuDetails`,
      receiptList: `${concessionServiceBaseUrl}/paymentManagement/CHKL/searchAllReceipts`,
      depositedList: `${concessionServiceBaseUrl}/paymentManagement/CHKL/searchAllDepositSlips`,
      updateChequeStatus: `${concessionServiceBaseUrl}/paymentManagement/CHKL/updateStatus`,
      sendForApproval: `${concessionServiceBaseUrl}/paymentManagement/chkl/sendForApproval?paymentMode=chkl`,
      depositCheque: `${concessionServiceBaseUrl}/paymentManagement/chkl/depositSlip/save`,
      revokeCheque: `${concessionServiceBaseUrl}/paymentManagement/chkl/sendForRevoke?paymentMode=chkl`,
      downloadReport: `${concessionServiceBaseUrl}/paymentManagement/chkl/sendPaymentReceiptsViaEmail`,
      getChequeDetails: `${concessionServiceBaseUrl}/paymentManagement/CHKL/getChequeDetails`,
      chats: `${concessionServiceBaseUrl}/chat`,
    },

    approvalConfig: {
      create: `${concessionServiceBaseUrl}/charges/config?type=paymentManagementApprovalConfig`,
      update: `${concessionServiceBaseUrl}/charges/config?type=paymentManagementApprovalConfig`,
      getAll: `${concessionServiceBaseUrl}/charges/config?type=paymentManagementApprovalConfig`,
      search: `${concessionServiceBaseUrl}/charges/config/search?type=paymentManagementApprovalConfig`,
      delete: `${concessionServiceBaseUrl}/charges/config`,
      // logs: `${concessionServiceBaseUrl}/approvalConfig/logs`,
    },
    depositSlip: {
      search: `${concessionServiceBaseUrl}/paymentManagement/cash/searchDepositSlips`,
      update: `${concessionServiceBaseUrl}/paymentManagement/cash/notifyAndUpdateApprovalStatus`,
    },
    viewDetails: {
      search: `${concessionServiceBaseUrl}/paymentManagement/cash/searchReceiptByDepositSlip`,
      logs: `${concessionServiceBaseUrl}/paymentManagement/cash/depositSlipHistory`,
    },
  },
  chequeManagement: {
    dateExtension: {
      search: `${concessionServiceBaseUrl}/paymentManagement/chkl/searchDepositSlips`,
      update: `${concessionServiceBaseUrl}/paymentManagement/chkl/notifyAndUpdateApprovalStatus`,
      audit: `${concessionServiceBaseUrl}/paymentManagement/chkl/chequeHistory`,
    },
  },
  outstanding: {
    getAllStudentApplications: `${concessionServiceBaseUrl}/outstanding/getAllStudentApplications`,
    reminder: `${concessionServiceBaseUrl}/outstanding/reminder`,
    getRemindersByApplicationId: `${concessionServiceBaseUrl}/outstanding/reminders`,
  },

  paymentTransfer: {
    search: `${concessionServiceBaseUrl}/paymentTransfer/getPaymentTransferBulkFileAuditDetails`,
    getBulkUploadDetailsByPid: `${concessionServiceBaseUrl}/paymentTransfer/getPaymentTransferProcessingDetailsByPid`,
  },

  allActiveBankAccounts: `${concessionServiceBaseUrl}/ledgerBankAccounts?offset=-1`,
  sapAccountMaster: {
    getAll: `${concessionServiceBaseUrl}/ledgerBankAccounts`
  },
  commissionReport: {
    search: `${concessionServiceBaseUrl}/commissionReport/search`,
    create: `${concessionServiceBaseUrl}/commissionReport/generate`,
    getBuListByPId: (processId) =>
      `${concessionServiceBaseUrl}/commissionReport/${processId}/business-areas`,
    getBuAndEmailsByPId: (processId) =>
      `${concessionServiceBaseUrl}/email/${processId}/business-areas`,
    sendEmail: `${concessionServiceBaseUrl}/email/send-report`,
    sapPosting: `${concessionServiceBaseUrl}/sap-posting`,
  },
  invoiceEngine: {
    qrCodeMonitor: {
      search: `${concessionServiceBaseUrl}/invoiceGenerator/searchThirdPartyTransactionDetails`,
      getJson: `${concessionServiceBaseUrl}/invoiceGenerator/getRequestByInvoiceAndBusinessArea`,
      retry: `${concessionServiceBaseUrl}/invoices/thirdParty/retry/byInvoice`
    }
  },

  voucherSetup : {
    search : `${concessionServiceBaseUrl}/voucherConfig/search`,
    create : `${concessionServiceBaseUrl}/voucherConfig/newConfig`,
    basePath : `${concessionServiceBaseUrl}/voucherConfig`,
    useVoucher : `${concessionServiceBaseUrl}/voucherConfig/useVoucher`,
  },

  stdOutCompare : `${concessionServiceBaseUrl}/std-out/compare`,
};
